import React, { useEffect, useState } from 'react';
import { useWallet } from '../hooks/useWallet';
import { contract, fmt, getLogs, KIND, TIER, tierLabel, shipImg } from '../lib';

function Marketplace() {
  const { account, send, nonce } = useWallet();
  const [rows, setRows] = useState(null);
  const [proceeds, setProceeds] = useState(0n);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const m = contract('Marketplace'); const ships = contract('Ships');
    (async () => {
      const ids = [...new Set((await getLogs(m, m.filters.Listed())).map((e) => e.args[0]))];
      const live = await Promise.all(ids.map(async (id) => {
        const l = await m.listings(id);
        if (l.seller === '0x0000000000000000000000000000000000000000') return null;
        const s = await ships.getShip(id);
        return { id, seller: l.seller, price: l.price, kind: KIND[Number(s.kind)], gen: Number(s.gen), rank: Number(s.rank), tier: TIER[Number(s.tier)], serial: Number(s.serial), level: Number(s.level), durability: Number(s.durability) };
      }));
      setRows(live.filter(Boolean).sort((a, b) => (a.price < b.price ? -1 : 1)));
      const [v, f, fee] = await Promise.all([m.totalVolume(), m.totalFees(), m.feeBps()]);
      setStats({ v, f, fee: Number(fee) });
      if (account) setProceeds(await m.proceeds(account));
    })().catch(() => setRows([]));
  }, [account, nonce]);

  const buy = (r) => send(`Buy #${r.id}`, (s) => contract('Marketplace', s).buy(r.id, r.price, { value: r.price }));
  const cancel = (r) => send(`Take ship #${r.id} off sale`, (s) => contract('Marketplace', s).cancel(r.id));
  const mine = (r) => account && r.seller.toLowerCase() === account.toLowerCase();

  return (
    <div className="market-container" style={{ maxWidth: 1100 }}>
      <h1>Marketplace</h1>
      <p style={{ color: 'var(--muted)' }}>{stats ? stats.fee / 100 : 5}% fee · volume <span data-testid="volume">{stats ? fmt(stats.v) : '…'}</span> BNB</p>
      {account && (
        <div className="card" style={{ marginTop: '1rem' }} data-testid="proceeds">
          <h3>Your proceeds</h3>
          <p className="price">{fmt(proceeds, 5)} BNB</p>
          <button className="action-btn" disabled={proceeds === 0n} onClick={() => send('Withdraw proceeds', (s) => contract('Marketplace', s).withdraw())}>Withdraw</button>
        </div>
      )}
      {rows === null ? <p style={{ marginTop: '1rem' }}>Loading listings…</p> : rows.length === 0 ? (
        <div className="card" style={{ marginTop: '1.5rem' }}><h3>No listings yet</h3><p>List a ship from your Fleet page.</p></div>
      ) : (
        <div className="ship-grid" data-testid="listings">
          {rows.map((r) => (
            <div key={String(r.id)} className={`ship-card${r.kind === 'Pirate' ? ' pirate' : ''}`}>
              <img src={shipImg(r)} alt={tierLabel(r)} style={{ width: 64, height: 64, imageRendering: 'pixelated' }} />
              <h3>#{String(r.id)}</h3>
              <p className={`tier tier-${String(r.tier).toLowerCase()}`}>{tierLabel(r)}</p>
                <p>{r.kind} · Gen{r.gen}{r.kind === 'Pirate' ? ` · Rank ${r.rank}` : ` · Lv ${r.level}`}</p>
              <p className="stat">DUR {r.durability}/10</p>
              <p className="price" style={{ marginTop: '.5rem' }}>{fmt(r.price)} BNB</p>
              {mine(r) ? <button className="action-btn" onClick={() => cancel(r)}>Cancel listing</button> : <button className="action-btn" onClick={() => buy(r)}>Buy</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Marketplace;
